<template>
  <div
    class="tab-pane fade"
    id="nav-registration"
    role="tabpanel"
    aria-labelledby="nav-registration-tab"
  >
    <div class="container-fluid" v-if="registration">
      <div class="row">
        <div class="col-sm-12 mt-2">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-xl-12">
                <h5 class="d-inline pr-1">Current Status:</h5>
                <p class="d-inline">{{registration.LifecycleStatus | splitString}}</p>
              </div>
            </div>

            <div class="h-timeline">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <ul class="timeline timeline-horizontal">
                      <li
                        class="timeline-item"
                        v-for="(reg, index) in filteredRegistration"
                        :key="index"
                      >
                        <div class="timeline-badge complete"></div>
                        <div v-if="reg.RegistrationStatus == 'Failed'" class="timeline-badge issue"></div>
                        <div v-else class="timeline-badge complete"></div>
                        <div class="timeline-panel">
                          <div class="timeline-heading">
                            <h5 class="timeline-title">{{reg.Narrative}}</h5>
                          </div>
                          <div class="timeline-body">
                            <p>{{reg.EffectiveDate | shortDate}}</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _filters from "@/mixins/filters";

export default {
  name:'registration',
  mixins: [_filters],
  computed: {
    services() {
      const sorted = this.$_.sortBy(this.$store.state.contracts.services, function(service) {
        return service.Contract && service.Contract.ContractStatus === 'Chargeable' ? 0 : 1;
      });
      return this.$_.uniq(sorted, function(service) {
        return service.Service.ServiceIdentifier;
      });
    },
    activeService() {
      if (!this.$store.state.meters.activeService) {
        this.$store.dispatch("changeActiveService", this.services[0]);
      }
      return this.$store.state.meters.activeService;
    },
    registration() {
      if (this.$store.state.meters.activeService) {
        return this.$store.state.meters.activeService.Registration;
      }
    },
    orderedRegistration() {
      return this.$_.sortBy(this.registration.Timeline, "EffectiveDate");
    },
    filteredRegistration() {
      let lastNarative = null,
        filteredRegistration = [];
      for (var i = 0; i < this.orderedRegistration.length; i++) {
        if (this.orderedRegistration[i].Narrative !== lastNarative) {
          filteredRegistration.push(this.orderedRegistration[i]);
        } else {
          filteredRegistration[
            filteredRegistration.length - 1
          ] = this.orderedRegistration[i];
        }
        lastNarative = this.orderedRegistration[i].Narrative;
      }
      return filteredRegistration;
    }
  },
  methods: {}
};
</script>